module.exports = __webpack_public_path__ + "img/ios.22086a2d.png";